<template>
    <div class="container-fluid">
        <notifications></notifications>

        <div class="confirm">
            <div class="card text-center p-sm-5 p-3" style="width: 25rem;">
                <h5 class="card-title"><img src="/assets/logo/logo_white.svg" alt=""></h5>

                <div class="card-body">
                    <div v-if="$route.params.status == 'success'" class="alert alert-success mt-5" role="alert">
                        Uw machtiging is succesvol voortaan kunt u gebruik maken van de automatische incasso.
                    </div>
                    
                    <div v-else class="alert alert-danger mt-5" role="alert">
                        Helaas is uw betaling mislukt, probeer opnieuw of neem contact op met de vereniging. De status die wij hebben ontvangen omtrent uw betaling is: {{ $route.params.status }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "first-payment-confirm"
    }
</script>


<style scoped>
    .container-fluid {
        height: 100vh;
        background: transparent linear-gradient(270deg, #73AFE3 0%, #CFE4F6 100%) 0% 0% no-repeat padding-box;
        opacity: 1;
    }

    .confirm {
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
    }

    .card {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 20px;
        opacity: 1;
    }

    .form-control {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        height: calc(1.5em + .75rem + 8px) !important;
        font-size: 15px !important;
    }

    .text-white {
        font-size: 15px !important;
    }

    .btn {
        background: #292929 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        padding-left: 15%;
        padding-right: 15%;
        font-size: 18px !important;
    }


</style>
